/** Browser-level preferences the whole app reacts to. */
export const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
